//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {MessageBox, Toast,Popup } from 'mint-ui'
import userApi from '@/api/user'
import {Const} from '@/consts'
import utils from '@/utils'
import api from '@/api/index'

export default {
    data() {
        return {
            info: {
                account: '',
                password: '',
                validCode: ''
            },
            validCodeUrl: '',
            validCodeToken: '',
            failedCount: 0,
            title: '',
            popupVisible: false,
            loginclick:false,//控制点击事件防止多次提交
            datasessionId:"0",
            datasig:"0",
            datatoken:"0",
            scene:"ic_activity_h5"//标识符-不可改变

        }
    },

    created() {
        utils.save('USER_TYPE', 'TOURIST')// 用户类型-游客
        if (utils.get('AUTOREPLACE')) {
            utils.save('AUTOREPLACE', false)// 自动刷新-刷新WebSoket
            location.reload()
        }
        this.failedCount = utils.get('LOGIN_FAILED_COUNT') || 0
        /* if (this.failedCount >= 5) {
          this.getValidCode()
        } */


        // 自动登录
        if (this.$route.query.autoLogin === 'true') {

            this.login()

        }
        // this.set_ALY_config()
        // 保证先在window下存在变量NVC_Opt再去加载js文件
        // this.set_ALY_config()

    },
    mounted() {
        let me = this
        // 获取首页数据(轮播图
        api.getIndex({
            params: {
                pagesize: 5,
                yumingHost: window.location.host
            }
        }).then(resp => {
            console.log(resp.result)
            utils.save('title', resp.result.title)
            utils.save('allowMobileRegister', resp.result.allowMobileRegister)
            window.document.title = resp.result.title + '职业培训网络平台'
            this.title = resp.result.title + '职业培训网络平台'
        }).catch((resp) => {
            if (resp.statusCode === '200') {
                // eslint-disable-next-line no-undef
                // Toast(resp[Const.RESP_NOTOK_MESSAGE] || '获取信息失败')
                MessageBox.alert('请求超时').then(action => {
                    this.$router.push({
                        path: '/index'
                    })
                });
            } else {
                MessageBox.alert('请求超时').then(action => {
                    this.$router.push({
                        path: '/index'
                    })
                });

            }
        })

        if (typeof (this.$route.query.phoneno) !== 'undefined') {
            this.info.account = this.$route.query.phoneno
            this.info.password = '123456789'
            this.info.validCode = 1234
            me.login()

        }
        this.set_ALY_config()
    },

    methods: {
        // 拦截贴贴事件
        paste (e) {
            e.preventDefault()
            return ""
        },
        formatParams() {
            let id = null;
            if (typeof (this.$route.query.id) !== 'undefined') {
                id = this.$route.query.id
            }
            if (typeof (this.$route.query.phoneno) !== 'undefined') {
                this.info.account = this.$route.query.phoneno
            }
            let data = {
                params: {
                    phoneNo: this.info.account,
                    passWord: this.info.password,
                    yumingHost: window.location.host,
                    security: this.id,
                    sessionId:this.datasessionId,
                    sig:this.datasig,
                    token:this.datatoken,
                    scene:this.scene//标识符-不可改变
                },
                headers: {}
            }

            data.headers[Const.H_VERIFICATION_CODE] = this.info.validCode
            data.headers[Const.H_VERIFICATION_CODE_TOKEN] = this.validCodeToken

            return data
        },
        login () {
            if (!this.info.account) {
                Toast('请填写登录手机号')
                return
            }

            if (!this.info.password) {
                Toast('请填写密码')
                return
            }

            if (this.failedCount >= 15 && !this.info.validCode) {
                Toast('请填写验证码')
                return
            }
            console.log("登录请求！")
            if(this.loginclick){
                return
            }
            this.loginclick=true;
            userApi.login(this.formatParams()).then(resp => {
                this.datasessionId="0"
                this.datasig="0"
                this.datatoken="0"
                let re = resp[Const.RESP_RESULT] || '';
                if(resp.message==='需要认证'){

                    const msgText = '<div class="text-justify" style="line-height: 25px;">根据监管要求，登录系统需要确认你的身份，请按照提示进行。<div>'

                    MessageBox.confirm(msgText, '人脸核验', {
                        confirmButtonText: '开始验证',
                        cancelButtonText: '退出登录',
                        closeOnClickModal: false,
                        type: 'info'
                    }).then(action => {
                        var opened = window.open(re, '_self')
                        opened.opener = null
                    }, action => {
                        this.goBack()
                    }).catch(() => {

                    })
                }else if(resp.message==='认证失败'){

                    const msgText = '<div class="text-justify" style="line-height: 25px;">此登录信息已过期请退出后重试。<div>'

                    MessageBox.confirm(msgText, '人脸核验失败', {
                        confirmButtonText: '确定',
                        cancelButtonText: '退出登录',
                        closeOnClickModal: false,
                        type: 'info'
                    }).then(action => {
                        var opened = window.open("http://"+window.location.host+'/#/index', '_self')
                        opened.opener = null
                    }, action => {
                        this.goBack()
                    }).catch(() => {

                    })
                }else{
                    // Toast(resp[Const.RESP_MESSAGE]);
                    // TODO: 跳转
                    utils.saveUserInfo(resp[Const.RESP_RESULT])
                    utils.clear('LOGIN_FAILED_COUNT')
                    utils.save('AUTOREPLACE', true)// 自动刷新-刷新WebSoket
                    // this.$router.replace('/index')
                    var opened = window.open("http://"+window.location.host+'/#/index', '_self')
                    opened.opener = null
                }
            }).catch(resp => {
                console.log(resp)
                if (resp.statusCode == '200') {
                    if(resp.msg==="运行时异常:此手机号未注册,请先注册"){
                        this.loginclick=false
                        this.popupVisible = false
                        Toast("此手机号未注册,请先注册")
                    }else{
                        this.loginclick=false
                        this.popupVisible = false
                        MessageBox.confirm(resp.message||resp.msg||'登录失败！', '登录失败', {
                            confirmButtonText: '确定',
                            closeOnClickModal: false,
                            type: 'info'
                        }).then(action => {
                            // console.log(resp.result.WapUrl)
                            if(resp.result.WapUrl!=null){
                                window.location.href = resp.result.WapUrl
                            }

                        }).catch(() => {
                            this.loginclick=false
                            this.popupVisible = false
                        })
                        //Toast(resp[Const.RESP_NOTOK_MESSAGE] || resp.message || '网络连接失败！请检查手机网络是否正常。')

                    }

                }
                // TODO: 记录失败次数
                this.failedCount++
                if (this.failedCount >= 15) {
                    this.getValidCode()
                }
                utils.save('LOGIN_FAILED_COUNT', this.failedCount)
                this.validCode = ''
                // if (resp.statusCode == '200') {
                //   Toast(resp[Const.RESP_MESSAGE] || '出错了 ...');
                // }
            })
        },

        register() {
            let isReg = utils.get("allowMobileRegister")
            console.log(isReg)
            if (isReg) {
                this.$router.push('/register')
            } else {
                Toast("请您联系学校或客服注册。");
            }

        },

        forgetPassword() {
            this.$router.push('/forgetpwd')
        },

        goHomePage() {
            this.$router.push('/index')
        },

        getValidCode() {
            userApi.getValidCodeImg({
                params: {
                    usage: 'LOGIN'
                }
            }).then(resp => {
                this.validCodeUrl = 'https://www.wfjtip.com' + resp[Const.RESP_RESULT] || ''
                this.validCodeToken = /\?token=([^ &]+)/.exec(this.validCodeUrl)[1] || ''
            }).catch(resp => {
                Toast(resp[Const.RESP_MESSAGE])
            })
        },
        set_ALY_config() {
            let _this=this
            AWSC.use("ic", function (state, module) {
                // 初始化
                window.ic = module.init({
                    // 应用类型标识。它和使用场景标识（scene字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的appkey字段值，请务必正确填写。
                    appkey: "FFFF0N0N00000000A446",
                    // 使用场景标识。它和应用类型标识（appkey字段）一起决定了智能验证的业务场景与后端对应使用的策略模型。您可以在阿里云验证码控制台的配置管理页签找到对应的scene值，请务必正确填写。
                    scene: "ic_activity",
                    // 声明智能验证需要渲染的目标元素ID。
                    renderTo: 'sc',
                    width: "100%",
                    // 验证通过时会触发该回调参数。您可以在该回调参数中将会话ID（sessionId）、签名串（sig）、请求唯一标识（token）字段记录下来，随业务请求一同发送至您的服务端调用验签。
                    success: function (data) {
                        window.console && console.log(data.sessionId)
                        window.console && console.log(data.sig)
                        window.console && console.log(data.token)
                        _this.datasessionId =data.sessionId;
                        _this.datasig =data.sig;
                        _this.datatoken =data.token;
                        _this.popupVisible = true
                        _this.captchareset()
                    },
                    // 验证失败时触发该回调参数
                    fail: function (failCode) {
                        console.log(failCode)
                        _this.captchareset()
                    },
                    // 验证码加载异常时触发该回调参数
                    error: function (errorCode) {
                        console.log(errorCode)
                        _this.captchareset()
                    }
                    // 该配置项为测试项 在仅用来测试验证码不同状态时使用。上线时请将其删除. 智能验证test配置项有4种不同的值对应不同的验证码状态，具体请参考文中参数定义说明部分。
                    // ,test: module.TEST_PASS, // 测试智能验证通过
                    // ,test: module.TEST_BLOCK, // 测试智能验证失败
                    // ,test: module.TEST_NC_PASS, // 唤醒滑动验证并验证通过
                    // ,test: module.TEST_NC_BLOCK, // 唤醒滑动验证并验证失败
                });
            })
        },
        captchareset(){
        /*datasessionId="0";
        datasig="0";
        datatoken="0";
        datalesson="0";*/
        window.ic.reset()
         },
        captchareset(){
        /*datasessionId="0";
        datasig="0";
        datatoken="0";
        datalesson="0";*/
        window.ic.reset()
         },
        loginPost(){
            let client = sessionStorage.getItem('client')
            console.log(client,'联系程序开发者')
            // alert('联系程序开发者');
            this.$post("login", {
                pwd: this.ruleForm.password,
                username: this.ruleForm.name,
                token: sessionStorage.getItem('token'),  //验证成功后台反的
                client: client,                       //随机数，后台找不到传给他的数据，另外加的   用来绑定用户唯一
            }).then(response => {
                if (response.code == 200) {

                    //
                    console.log(response);
                    this.$router.push({
                        path: "/home"
                    });
                    location.reload();
                } else {
                    sessionStorage.removeItem('token');
                    sessionStorage.removeItem('client');
                    this.msg = response.msg;
                    this.open4();
                    this.ruleForm.img = "";
                    this.ruleForm.img = baseURL.baseURL + "/imgCode?" + Math.random();
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/view/login/login.vue